import { render } from "./LiveRecords.vue?vue&type=template&id=4e18679f&scoped=true"
import script from "./LiveRecords.vue?vue&type=script&lang=js"
export * from "./LiveRecords.vue?vue&type=script&lang=js"

import "./LiveRecords.vue?vue&type=style&index=0&id=4e18679f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e18679f"]])

export default __exports__